import React from 'react';

import GenericField from './shared/GenericField';
import TextInputContainer from './text/TextInputContainer';

/**
 * Text field input.
 * @param {string} [label] Label description for field input.
 * @param {string} [initialValue] Field value.
 * @param {function} [handleSave] [async string=>{bool success, string message}] Save changes / return error message.
 */
const Text = ({ label, initialValue, handleSave: syncChanges }) => {
    return (
        <GenericField>
            {label}
            <TextInputContainer {...{ initialValue, syncChanges }} />
        </GenericField>
    );
};

export default Text;
